import { Reference } from '@apollo/client';
import { Page } from '../apollo/apollo-cache.ts';

export const MAX_CACHED_FEED_ITEMS = 500;

export const updateFeedCache = (
  existing:
    | Page
    | { items?: Array<Reference | unknown>; nextToken?: string | null }
    | undefined,
  newItemRef: Reference | null | undefined,
): Page => {
  const existingItems = existing?.items ?? [];
  const base = {
    ...existing,
    items: existingItems as Page['items'],
    nextToken: existing?.nextToken,
  } as Page;

  if (!newItemRef) {
    return base;
  }

  const idx = existingItems.findIndex(
    (item) => (item as Reference).__ref === newItemRef.__ref,
  );

  if (idx !== -1) {
    return {
      ...base,
      items: existingItems
        .slice(0, idx)
        .concat(newItemRef)
        .concat(existingItems.slice(idx + 1)) as Page['items'],
    };
  }

  const prepended = [newItemRef, ...existingItems];
  // At the cap prepends swap one-in-one-out: live posts can't grow the
  // cache and never mass-evict paginated scrollback.
  const items =
    prepended.length > MAX_CACHED_FEED_ITEMS
      ? prepended.slice(0, prepended.length - 1)
      : prepended;

  return {
    ...base,
    items: items as Page['items'],
  };
};
